import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RedirectToOCMS() {
  const navigate = useNavigate();

  useEffect(() => {
    // Get token from localStorage
    const token = localStorage.getItem('ans-sms.token') || localStorage.getItem('ans-sms');

    if (!token) {
      // No token, redirect to login
      navigate('/login', { state: { warning: 'Please login first' } });
      return () => {}; // Return empty cleanup function for consistency
    }

    // Redirect to OCMS after 3 seconds
    const timer = setTimeout(() => {
      // Resolve OCMS base URL: env var -> localStorage -> host-aware default
      const envBase = process.env.REACT_APP_OCMS_URL;
      const storedBase = localStorage.getItem('ocms.baseUrl');
      const { hostname, protocol } = window.location;
      const isLocal = ['localhost', '127.0.0.1'].includes(hostname);
      const isHttps = protocol === 'https:';

      let hostAwareDefault;
      if (isLocal) {
        hostAwareDefault = 'http://localhost:3001';
      } else if (isHttps) {
        hostAwareDefault = 'https://sms.caa.co.ug:3001';
      } else {
        hostAwareDefault = 'http://10.10.32.25:3001';
      }
      const base = (envBase || storedBase || hostAwareDefault).replace(/\/$/, '');
      const ocmsUrl = `${base}/admin?token=${encodeURIComponent(token)}&app=sms`;
      window.open(ocmsUrl, '_blank', 'noopener,noreferrer');
      // Go back to previous page in SMS app
      navigate(-1);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="text-center space-y-6 p-8">
        {/* Animated Spinner */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-20 h-20 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-12 h-12 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin animate-reverse" style={{ animationDuration: '1.5s' }} />
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-gray-800">
            Redirecting to OCMS
          </h2>
          <p className="text-gray-600 animate-pulse">
            Opening Online Course Management System
            <span className="inline-block animate-bounce">.</span>
            <span className="inline-block animate-bounce" style={{ animationDelay: '0.2s' }}>.</span>
            <span className="inline-block animate-bounce" style={{ animationDelay: '0.4s' }}>.</span>
          </p>
        </div>

        {/* Progress Bar */}
        <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden mx-auto">
          <div
            className="h-full bg-gradient-to-r from-blue-600 to-purple-600 rounded-full animate-progress"
            style={{
              animation: 'progress 3s ease-in-out forwards',
            }}
          />
        </div>

        {/* Info */}
        <p className="text-sm text-gray-500 max-w-md">
          A new window will open with the OCMS dashboard.
          Your session from SMS will be automatically transferred.
        </p>
      </div>

      <style>
        {`
        @keyframes progress {
          from { width: 0%; }
          to { width: 100%; }
        }
        
        @keyframes reverse {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        
        .animate-reverse {
          animation-direction: reverse;
        }
      `}
      </style>
    </div>
  );
}
